export default "__VITE_ASSET__BF_E1kH3__"